import React, { useState } from 'react';

import { DialogActions, Typography } from '@mui/material';
import { AlineTextarea } from 'src/components';
import type { WorkflowCollaborator } from 'src/components';
import { AlineButton, AlineDialog } from 'src/components/generic';
import { PersonIcon } from 'src/components/icons/PersonIcon';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  label: {
    ...theme.appTypography.fieldLabel,
  },
  paper: {
    width: theme.dialogStyles.standardDialogWidth,
  },
  title: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
  },
}));

interface GrantWorkflowPermissionAccessDiaolgProps {
  collaborator: Pick<WorkflowCollaborator, 'id' | '__typename'>;
  onClose: () => void;
  open: boolean;
}

export function GrantWorkflowPermissionAccessDiaolg({
  collaborator,
  onClose,
  open,
}: GrantWorkflowPermissionAccessDiaolgProps) {
  const { classes } = useStyles();
  const [message, setMessage] = useState('');
  const [updateWorkflowPermission, { loading: isSubmitting }] =
    Apollo.useUpdateWorkflowPermissionMutation();

  return (
    <AlineDialog
      classes={{ paper: classes.paper }}
      open={open}
      title={
        <div className={classes.title}>
          <PersonIcon />
          <Typography variant="h1">Grant Collaborator Access</Typography>
        </div>
      }
      onClose={onClose}
    >
      <div className={classes.dialog}>
        <Typography className={classes.label}>Message</Typography>
        <AlineTextarea
          maxRows={4}
          minRows={4}
          placeholder="Add a message for the recipient..."
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
      </div>
      <DialogActions>
        <AlineButton color="primary" variant="outlined" onClick={onClose}>
          Cancel
        </AlineButton>
        <AlineButton
          color="primary"
          loading={isSubmitting}
          variant="contained"
          onClick={async () => {
            await updateWorkflowPermission({
              variables: {
                input: {
                  message,
                  props: { timeliness: Apollo.WorkflowPermissionTimeliness.Active },
                  workflowPermissionId: collaborator.id,
                },
              },
            });
            onClose();
          }}
        >
          Grant Access
        </AlineButton>
      </DialogActions>
    </AlineDialog>
  );
}
